import { Reducer } from 'redux'
import { IKlantKoppelingState } from '../interfaces'
import { Actions, KlantKoppelingAction } from '../actions/klantKoppelingAction'
import { VestigingEnum } from 'shared/models/Enum'

const initialState: IKlantKoppelingState = {
  loading: false,
  selectie: {
    afleverAfspraakId: undefined,
    klantNummer: undefined,
    klantNaam: undefined,
    vestiging: VestigingEnum.Geen,
    klantGroepId: undefined,
  },
  foutmelding: undefined,
  koppelingen: undefined,
  koppelklant: undefined,
  klantGroepen: undefined,
  klantAfleverafspraken: undefined,
  alleKlantGroepen: undefined,
  selectieKlantGroepen: undefined,
}

export const klantKoppelingReducer: Reducer<
  IKlantKoppelingState,
  KlantKoppelingAction
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetKlantKoppelingRequest:
      return {
        ...state,
        loading: true,
        selectie: action.payload,
        foutmelding: null,
        koppelklant: null,
        koppelingen: [],
      }
    case Actions.GetKlantKoppelingResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        koppelingen: action.success ? action.payload : [],
      }
    case Actions.PostKlantKoppelingRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.PostKlantKoppelingResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
        koppelklant: null,
      }
    case Actions.DeleteKlantKoppelingRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.DeleteKlantKoppelingResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
        koppelklant: null,
      }
    case Actions.GetKlantGroepenVestigingRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.GetKlantGroepenVestigingResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        klantGroepen: action.success ? action.payload : [],
      }
    case Actions.GetKlantGroepenSelectieRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.GetKlantGroepenSelectieResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        selectieKlantGroepen: action.success ? action.payload : [],
      }
    case Actions.GetKlantGroepenVestigingCache:
      return { ...state, loading: false, alleKlantGroepen: action.payload }
    case Actions.GetKlantGegevensRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.GetKlantGegevensResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        koppelklant: action.success ? action.payload : null,
      }
    case Actions.GetKlantGegevensFout:
      return { ...state, loading: false, foutmelding: action.payload }
    case Actions.GetKlantAfleverafsprakenVestigingRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.GetKlantAfleverafsprakenVestigingResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        klantAfleverafspraken: action.success ? action.payload : [],
      }
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
